import { TweenMax } from 'gsap';
import { Vector3, Euler, Quaternion } from 'three';
import { mod } from './mod';
import EventBus from './EventBus.js';
// import tweenSpeedsMixin from './tweenSpeedsMixin';

export default class Rotator {
  constructor(rotationTarget, cameraTarget) {
    this._camera = {
      obj: null,
      target: cameraTarget,
      interpolation: {
        active: false,
        offset: new Vector3(0, 0, 0)
      }
    };
    this._rotating = {
      previous: 0,
      current: 0,
      initial: 0,
      amount: 10,
      target: rotationTarget,
      multiplier: 0.2
    };
    this.autoLook = false;
    this.gameEnabled = false;
    this.isSnapping = false;
    this.isDragging = false;
    this.canSnap = false;
    this.snapSpeed = 1;
    this.snapRotations = [
      new Quaternion(0, 0.11246066642363464, 0, 0.9936561772099813),
      new Quaternion(0, -0.5478574015278386, 0, 0.836571734874675),
      new Quaternion(0, 0.9925790557823604, 0, -0.12160106094192813),
      new Quaternion(0, 0.8193057293996032, 0, 0.5733568886592305)
    ];
    // this.snapRotations = [Math.PI * 0.25, Math.PI * 0.75, Math.PI * -0.25, Math.PI * -0.75]
    this.snapIndex = 0;

    this.previousIndex = 0;
    this.currentIndex = 0;
    this.currentFloor = 0;

    this.floorObjects = [
      { group: null, offset: 0 },
      { group: null, offset: 5 }
    ];

    this.PrintTarget = this.PrintTarget.bind(this);
    document.body.onkeyup = this.PrintTarget;

    this.snapStartEvent = new CustomEvent('snapStartEvent');
    this.snapEndEvent = new CustomEvent('snapEndEvent');
  }
  PrintTarget(e) {
    // console.log('Attemping to force rotation of target')
    if (this._rotating.target == null) {
      return;
    }

    if (e.keyCode === 88 || e.key === ' ') {
      // console.log(this._rotating.target.quaternion)
      // this._rotating.target.setRotationFromQuaternion(this.snapRotations[this.snapIndex])
      // console.log(this._rotating.target.quaternion)
      // this.snapIndex = (this.snapIndex + 1) % 4
    }
  }

  GetCurrentIndex() {
    return this.currentIndex;
  }

  GetPreviousIndex() {
    return this.previousIndex;
  }

  IncrementRoomIndex() {
    this.previousIndex = this.currentIndex;
    this.currentIndex = (this.currentIndex + 1) % EventBus.roomAmount;
    this.isSnapping = true;
    window.dispatchEvent(this.snapStartEvent);
  }

  DecrementRoomIndex() {
    this.isSnapping = true;
    this.previousIndex = this.currentIndex;
    this.currentIndex = mod(this.currentIndex - 1, EventBus.roomAmount);
    window.dispatchEvent(this.snapStartEvent);
  }

  SetRoomIndex(next) {
    this.previousIndex = this.currentIndex;
    this.currentIndex = next;
    this.isSnapping = true;
    // console.log(`prev: ${this.previousIndex} cur: ${this.currentIndex}`)
    window.dispatchEvent(this.snapStartEvent);
  }

  UpdateRotation(moveAmount, camera, scene) {
    this._rotating.target.rotateY(moveAmount * 0.005);
  }

  TestRotation(moveAmount) {
    let rotSpeed = moveAmount * 0.005;
    let targetRotation = new Quaternion();
    targetRotation.copy(this._rotating.target.quaternion);

    var q1 = new Quaternion();
    q1.setFromAxisAngle(new Vector3(0, 1, 0), rotSpeed);

    targetRotation.multiply(q1);

    return targetRotation;
  }
  HandleRotation(camera, scene) {
    camera.lookAt(this._camera.target.position);
    if (this.isSnapping && !this.isDragging && this.canSnap) {
      // autosnap to one of our four points
      this.SnapCamera();
    }

    this.UpdateRotation(this._rotating.amount, camera, scene);

    // slowly send it back to 0
    if (this._rotating.amount > 0) {
      this._rotating.amount = Math.max(
        0,
        this._rotating.amount - this.snapSpeed
      );
    } else {
      this._rotating.amount = Math.min(
        0,
        this._rotating.amount + this.snapSpeed
      );
    }
  }

  SnapCamera() {
    if (this._camera.obj == null) return;

    if (!this.gameEnabled) {
      this.RotateToRoom(this.GetCurrentIndex());
      return;
    }
    // console.log(`prev: ${this.GetPreviousIndex()} next: ${this.GetCurrentIndex()}`)
    // logic to figure out when to go up or down a floor
    if (this.currentFloor === 0) {
      if (this.GetCurrentIndex() === 4 || this.GetCurrentIndex() === 5) {
        this.LoadFloor(1);
      }
    }
    if (this.currentFloor === 1) {
      if (
        this.GetCurrentIndex() === 0 ||
        this.GetCurrentIndex() === 1 ||
        this.GetCurrentIndex() === 2 ||
        this.GetCurrentIndex() === 3
      ) {
        this.LoadFloor(0);
      }
    }
    this.RotateToRoom(this.GetCurrentIndex());
  }

  RotateToRoom(roomIndex) {
    const goalRotation = this.snapRotations[roomIndex % 4];
    const nextRotation = this._rotating.target.quaternion.rotateTowards(
      goalRotation,
      0.05
    );
    const closeness = nextRotation.angleTo(goalRotation);

    if (closeness < 0.0005) {
      this.isSnapping = false;
      window.dispatchEvent(this.snapEndEvent);
    }
  }

  LoadFloor(floorIndex) {
    if (this._camera.interpolation.active) return;
    this.InterpolateCamera(
      this.floorObjects[(floorIndex + 1) % 2].offset,
      this.floorObjects[floorIndex].offset
    );
    this.currentFloor = floorIndex;
  }

  InterpolateCamera(start, end) {
    this._camera.interpolation.offset.y = this._camera.obj.position.y;
    this._camera.interpolation.active = true;

    TweenMax.to(this._camera.obj.position, 0.5, {
      y: end + 10,
      ease: 'Power2.easeInOut'
    });
    this.DoneInterpolateCamera = this.DoneInterpolateCamera.bind(this);
    TweenMax.to(this._camera.target.position, 0.5, {
      y: end,
      onComplete: this.DoneInterpolateCamera,
      ease: 'Power2.easeInOut'
    });
  }

  DoneInterpolateCamera() {
    this._camera.interpolation.active = false;
    // console.log('Done interpolating')
  }

  calculateDrag(mouseX) {
    let dragDistance = (this._rotating.initial - mouseX) * -1;
    this._rotating.previous = this._rotating.current;
    this._rotating.current = dragDistance;

    let delta = this._rotating.current - this._rotating.previous;

    this._rotating.amount = delta;
    this._rotating.amount =
      this._rotating.amount > 0
        ? Math.min(this._rotating.amount, 10)
        : Math.max(this._rotating.amount, -10);
  }

  MouseRotating(e) {
    e.preventDefault();
    if (this._camera.interpolation.active) return;
    this.calculateDrag(e.clientX);
  }

  MouseRotate(e) {
    // debugger;
    e.preventDefault();
    if (this._camera.interpolation.active) return;
    this.isDragging = true;
    this._rotating.initial = e.clientX;
    // this lets the mouse drag continue to rotate object even when no longer over scrollbar element
    this.MouseRotating = this.MouseRotating.bind(this);
    window.addEventListener('mousemove', this.MouseRotating);
  }

  StopMouseRotate(e) {
    if (typeof e.cancelable !== 'boolean' || e.cancelable) {
      e.preventDefault();
    }

    if (!this.isDragging) {
      return;
    }
    this.isDragging = false;
    this._rotating.previous = 0;
    this._rotating.current = 0;

    if (this.canSnap) {
      if (this._rotating.amount < 0) {
        this.IncrementRoomIndex();
      } else {
        this.DecrementRoomIndex();
      }
    }
    // now we return to only listening for clicks of the scrollbar
    window.removeEventListener('mousemove', this.MouseRotating);
  }
  TouchRotate(e) {
    // same as the mouse functions
    if (this._camera.interpolation.active) return;
    this.isDragging = true;
    this._rotating.initial = e.touches[0].clientX;
    this.TouchRotating = this.TouchRotating.bind(this);
    window.addEventListener('touchmove', this.TouchRotating);
  }
  TouchRotating(e) {
    if (this._camera.interpolation.active) return;
    this.calculateDrag(e.touches[0].clientX);
  }
  StopTouchRotate(e) {
    if (typeof e.cancelable !== 'boolean' || e.cancelable) {
      e.preventDefault();
    }
    // return to only listening for touch of scrollbar
    if (!this.isDragging) {
      return;
    }
    this.isDragging = false;

    window.removeEventListener('touchmove', this.TouchRotating);
    if (this._rotating.amount < 0) {
      this.IncrementRoomIndex();
    } else {
      this.DecrementRoomIndex();
    }
  }
  StopRotate(e) {
    if (typeof e.cancelable !== 'boolean' || e.cancelable) {
      e.preventDefault();
    }
  }
  RotateLeft(e) {
    e.preventDefault();
    this.RemoveCurrentIndicator();
    if (this._camera.interpolation.active) return;
    if (this.isSnapping) return;
    this.IncrementRoomIndex();
  }
  RotateRight(e) {
    e.preventDefault();
    this.RemoveCurrentIndicator();
    if (this._camera.interpolation.active) return;
    if (this.isSnapping) return;
    this.DecrementRoomIndex();
  }

  RemoveCurrentIndicator() {
    let el = document.querySelector('.current-indicator');

    if (el) {
      el.classList.remove('current-indicator');
    }
  }

  AddMouseEvent(bgScroll) {
    // this one is for fullscreen dragging, intended for splash page
    // debugger;
    this.MouseRotate = this.MouseRotate.bind(this);
    bgScroll.addEventListener('mousedown', this.MouseRotate);

    this.StopMouseRotate = this.StopMouseRotate.bind(this);
    window.addEventListener('mouseup', this.StopMouseRotate);
  }

  AddTouchEvent(bgScroll) {
    // touch listener for dragging via scrollbar
    this.TouchRotate = this.TouchRotate.bind(this);
    bgScroll.addEventListener('touchstart', this.TouchRotate);

    this.StopTouchRotate = this.StopTouchRotate.bind(this);
    window.addEventListener('touchend', this.StopTouchRotate);
  }

  DestroySplashEvents(bgScroll) {
    bgScroll.removeEventListener('mousedown', this.MouseRotate);
    window.removeEventListener('mouseup', this.StopMouseRotate);
    bgScroll.removeEventListener('touchstart', this.TouchRotate);
    window.removeEventListener('touchend', this.StopTouchRotate);
  }

  AddMouseEvents(bgScroll, leftScroll, rightScroll) {
    // mouse listener for dragging via scrollbar
    this.MouseRotate = this.MouseRotate.bind(this);
    bgScroll.addEventListener('mousedown', this.MouseRotate);

    this.StopMouseRotate = this.StopMouseRotate.bind(this);
    window.addEventListener('mouseup', this.StopMouseRotate);

    // left scroll arrow
    this.RotateLeft = this.RotateLeft.bind(this);
    leftScroll.addEventListener('mousedown', this.RotateLeft);

    this.StopRotate = this.StopRotate.bind(this);
    window.addEventListener('mouseup', this.StopRotate);

    // right scroll arrow
    this.RotateRight = this.RotateRight.bind(this);
    rightScroll.addEventListener('mousedown', this.RotateRight);

    // we've already bound this.StopRotate to our local scope
    // window.addEventListener('mouseup', this.StopRotate)
  }

  AddTouchEvents(bgScroll, leftScroll, rightScroll) {
    // touch listener for dragging via scrollbar
    this.TouchRotate = this.TouchRotate.bind(this);
    bgScroll.addEventListener('touchstart', this.TouchRotate);

    this.StopTouchRotate = this.StopTouchRotate.bind(this);
    window.addEventListener('touchend', this.StopTouchRotate);

    // touch handlers for left arrow
    this.RotateLeft = this.RotateLeft.bind(this);
    leftScroll.addEventListener('touchstart', this.RotateLeft);

    this.StopRotate = this.StopRotate.bind(this);
    window.addEventListener('touchend', this.StopRotate);

    // touch handlers for right arrow
    this.RotateRight = this.RotateRight.bind(this);
    rightScroll.addEventListener('touchstart', this.RotateRight);

    // window.addEventListener('touchend', this.StopRotate)
  }

  DestroyAllListeners(bgScroll, leftScroll, rightScroll) {
    bgScroll.removeEventListener('mousedown', this.MouseRotate);
    window.removeEventListener('mouseup', this.StopMouseRotate);

    leftScroll.removeEventListener('mousedown', this.RotateLeft);
    window.removeEventListener('mouseup', this.StopRotate);

    rightScroll.removeEventListener('mousedown', this.RotateRight);
    window.removeEventListener('mouseup', this.StopRotate);

    bgScroll.removeEventListener('touchstart', this.TouchRotate);
    window.removeEventListener('touchend', this.StopTouchRotate);

    leftScroll.removeEventListener('touchstart', this.RotateLeft);
    window.removeEventListener('touchend', this.StopRotate);

    rightScroll.removeEventListener('touchstart', this.RotateRight);
    window.removeEventListener('touchend', this.StopRotate);
  }
}



// WEBPACK FOOTER //
// ./src/plugins/FixedRotate.js